import '../styles/application.scss';
import '../utils/initRailsUJS';
import '../utils/cable';
import ReactOnRails from 'react-on-rails';

import Accounts from '../components/accounts';
import AccountsShow from '../components/accounts/Show';
import Administrator from '../components/administrators/Show'; //Show
import Administrators from '../components/administrators'; //Index
import AdminHeader from '@reactiveonline/reactive_admin_shared-packages/AdminHeader';
import AdminSidenav from '@reactiveonline/reactive_admin_shared-packages/AdminSidenav';
import Announcements from '../components/announcements';
import Dashboard from '../components/dashboard/index';
import Home from '../components/home';
import Onboardings from '../components/onboardings';
import PasswordsEdit from '../components/passwords/Edit';
import PasswordsNew from '../components/passwords/New';
import ReportsShow from '../components/reports/Show';
import ReportsTenantShow from '../components/reports/TenantShow';
import SessionsNew from '../components/sessions/New';
import SessionsSetPassword from '../components/sessions/SetPassword';
import Settings from '../components/settings';
import SubscriptionPayments from '../components/subscription_payments/SubscriptionPayments'

ReactOnRails.register({
  Accounts,
  AccountsShow,
  AdminHeader,
  AdminSidenav,
  Administrator,
  Administrators,
  Announcements,
  Dashboard,
  Home,
  Onboardings,
  PasswordsEdit,
  PasswordsNew,
  ReportsShow,
  ReportsTenantShow,
  SessionsNew,
  SessionsSetPassword,
  Settings,
  SubscriptionPayments
});
